import { AppThemeContext } from "contexts/AppThemeContext";
import { useContext } from "react";

const useAppTheme = () => useContext(AppThemeContext);

export default useAppTheme;
